import axios from 'axios';
import { apiCube, AuthorizationCube } from '../utils/index';

const prefix = 'TOTALS';

export const GET_TOTAL_START = `${prefix}_GET_START`;
export const GET_TOTAL_SUCCESS = `${prefix}_GET_SUCCESS`;
export const GET_TOTAL_ERROR = `${prefix}_GET_ERROR`;

function getTotalsStart() {
  return {
    type: GET_TOTAL_START
  };
}

function getTotalsSuccess(data) {
  return {
    type: GET_TOTAL_SUCCESS,
    payload: {
      data
    }
  };
}

function getTotalsError(error) {
  return {
    type: GET_TOTAL_ERROR,
    payload: {
      error
    }
  };
}

export function getTotals() {
  if (AuthorizationCube)
    axios.defaults.headers.common.Authorization = AuthorizationCube;

  const query = encodeURI(
    JSON.stringify({
      measures: ['Totals.count'],
      dimensions: ['Totals.reports', 'Totals.amount']
    })
  );

  return dispatch => {
    dispatch(getTotalsStart());
    return axios
      .get(`${apiCube}cubejs-api/v1/load?query=${query}`)
      .then(response => response.data)
      .then(data => dispatch(getTotalsSuccess(data)))
      .catch(error => dispatch(getTotalsError(error)));
  };
}
